module.exports = ""


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/tables/form-table/form-table-column/form-table-column.component.html
// module id = ../../../../../src/app/shared/components/tables/form-table/form-table-column/form-table-column.component.html
// module chunks = main